module.exports = __webpack_public_path__ + "static/media/HubitaWeb.20c71003.png";